import { gql } from "@apollo/client";

export const modalitiesQuery = gql`
  query modalities($scenarioId: ID!, $filter: ModalityFilterInput) {
    data(scenarioId: $scenarioId) {
      modalities(filter: $filter) {
        items {
          id
          code
          name
        }
        pageInfo {
          hasPreviousPage
          hasNextPage
          page
          size
          total
        }
      }
    }
  }
`;
